import type { FC } from "react"
import { cn } from "@/lib/utils"

type LogoProps = {
  alt?: string
  className?: string
}

export const Logo: FC<LogoProps> = ({ alt = "WarpMe Admin", className }) => {
  return (
    <img src="/warpme-admin-logo.svg" alt={alt} className={cn("h-[21px] w-[152px]", className)} />
  )
}
